export const MAIN_COLOR = 0x6cbfd6;
